import React from "react";
import { FormikProps, withFormik } from "formik";
import { FormStack } from "../components/FormStack/FormStack";
import {
  IntegrationFeatureProps,
  IntegrationGetWorkerStatusParameter,
} from "../components/Integration/IntegrationsFeatureParameter";
import {
  ChakraReactSelectField,
  SelectOption,
} from "../components/fields/SelectField/ChakraReactSelectField";
import { SingleValue } from "chakra-react-select";

interface GetIntegrationWorkerStatusParameterFormValues
  extends IntegrationGetWorkerStatusParameter {}

interface GetIntegrationWorkerStatusParameterFormProps
  extends IntegrationFeatureProps {
  workerStatus: string[];
  workerStatusIsLoading: boolean;
}

const InnerForm = ({
  setFieldValue,
  setFieldFeatureValue,
  workerStatus,
  workerStatusIsLoading,
}: GetIntegrationWorkerStatusParameterFormProps &
  FormikProps<GetIntegrationWorkerStatusParameterFormValues>) => {
  return (
    <FormStack>
      <ChakraReactSelectField
        horizontal
        label="Execution Id"
        name="executionId"
        selectedOptionColor="blue"
        className="relative-listbox"
        isLoading={workerStatusIsLoading}
        options={
          workerStatus?.map((data) => {
            return {
              label: data,
              value: data,
            };
          }) || []
        }
        onChange={(e) => {
          const value = (e as SingleValue<SelectOption>)?.value;
          setFieldValue("executionId", value);
          setFieldFeatureValue("executionId", value);
        }}
      />
    </FormStack>
  );
};

export const GetIntegrationWorkerStatusParameterForm = withFormik<
  GetIntegrationWorkerStatusParameterFormProps,
  GetIntegrationWorkerStatusParameterFormValues
>({
  mapPropsToValues: ({ feature }) => {
    if (!feature.parameter) {
      feature.parameter = {};
    }
    return { executionId: feature.parameter?.executionId };
  },
  handleSubmit: async (values, { props, setFieldError }) => {},
  validateOnBlur: false,
  validateOnMount: false,
  validateOnChange: false,
})(InnerForm);
